// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__VBHxu","block":"Footer_block__bANBC","info":"Footer_info__cETQF"};